import slick from 'slick-carousel';

// TOPページ　kvスライダー
$('.js-kv-slider').slick({
	autoplay: true,
	autoplaySpeed: 4000,
	speed: 2500,
	infinite: true,
	pauseOnHover: false,
	arrows: false,
	fade: true,
	slidesToShow: 1,
});

// TOPページ　pickupセクションのスライダー
$(function () {
  $(".js-intro-menuSlider")
		.on("init", function (event, slick) {
			$(this).append('<div class="slick-num"><span class="now-count"></span> / <span class="all-count"></span></div>');
			updateSlideCount(slick);
		})
		.slick({
			autoplaySpeed: 5000,
			infinite: true,
			pauseOnHover: false,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true, //spファーストの記述にしておく
			prevArrow: '<div class="prev"></div>',
			nextArrow: '<div class="next"></div>',
			responsive: [{
				//1024px以上の場合は3枚表示
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}]
		})
		.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
			updateSlideCount(slick, nextSlide);
		});

	function updateSlideCount(slick, nextSlide = slick.currentSlide) {
		const windowWidth = $(window).width();
		if (windowWidth <= 1023) {
			$(".now-count").text((nextSlide % 3) + 1); // 現在のスライド番号を3で割った余り
			$(".all-count").text(Math.ceil(slick.slideCount / 3)); // スライドの総数を3で割った数
		} else {
			// slick.optionsが存在するか確認
			if (slick && slick.options && slick.options.slidesToScroll) {
				$(".now-count").text(Math.ceil((nextSlide + 1) / slick.options.slidesToScroll)); // 現在のスライド番号をslidesToScrollの3枚単位で計算
				$(".all-count").text(Math.ceil(slick.slideCount / slick.options.slidesToScroll)); // スライドの総数をslidesToScrollの3枚単位で計算
			} else {
				console.error('slick.options.slidesToScroll is undefined');
			}
		}
	}

	$(window).on('resize', function() {
		const slickInstance = $(".js-intro-menuSlider").slick('getSlick');
		updateSlideCount(slickInstance);
	});
});

//TOPページ　店舗情報セクションのスライダー
$(function () {
  // メイン画像のオプション
  $(".js-info-slider").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    pauseOnHover: false,
    arrows: false,
    fade: true,
    infinite: true,
    asNavFor: ".js-info-thumbnail", // サムネイルと同期
  });

  // サムネイルのオプション
  $(".js-info-thumbnail").on('init', function(event, slick) {
    const slideCount = slick.slideCount;
    if (slideCount <= 5) {
      $(slick.$slider).addClass('no-slide');
    }
  }).slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 3,
    infinite: true,
		mobileFirst: true, //spファーストの記述にしておく
    asNavFor: ".js-info-slider", // メイン画像と同期
    focusOnSelect: true, // サムネイルクリックを有効化
    prevArrow: '<div class="prev"></div>',
    nextArrow: '<div class="next"></div>',
    responsive: [{
      // 1024px以上の場合は5枚表示
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    }]
  });

  // Slickを再初期化してイベントをトリガー
  $('.js-info-thumbnail').slick('setPosition');
});

// メニューページ　各メニュースライダー
$(document).ready(function() {
  $('.js-menu-slider').each(function() {
    const $slider = $(this);
    const $navContainer = $slider.next('.l-menu__sliderNav');

    $slider.slick({
      autoplay: false,
      autoplaySpeed: 5000,
      infinite: true,
      pauseOnHover: false,
      centerMode: true,
      centerPadding: "11px",
      slidesToShow: 1,
			mobileFirst: true, //spファーストの記述にしておく
      arrows: true,
      appendArrows: $navContainer,
      appendDots: $navContainer,
      prevArrow: '<div class="prev"></div>',
      nextArrow: '<div class="next"></div>',
      dots: true,
      responsive: [
        {
					// 1024px以上の場合は3枚表示
          breakpoint: 1024,
          settings: {
						centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }
      ]
    });
  });
});
